import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import login from './login.js'
import table from './table.js'
import form from './form.js'

const store = new Vuex.Store({
  getters: {
    alert: (state) => (msg, type) => {
      Vue.prototype.$notify.error({
        title: '系统提示',
        message: msg
      })
    }
  },
  modules: {
    login: login(Vue.prototype),
    table: table(Vue.prototype),
    form: form(Vue.prototype)
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js